<div class="modal-header">
    <h4 class="modal-title">Upload Document</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="close()"
    ></button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
        <label for="fileUpload" class="form-label">Select a file to upload:</label>
        <input
          type="file"
          class="form-control"
          id="fileUpload"
          (change)="onFileSelected($event)"
          [disabled]="isUploading"
        />
      </div>
      @if (isUploading) {
        <div class="progress mt-3">
          <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            [style.width.%]="uploadProgress"
          >
            {{ uploadProgress }}%
          </div>
        </div>
      }

      @if(savingMetadata && !isUploading){
        <div class="d-flex justify-content-center align-items-center mt-2">
          <i class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></i>
          <span>Saving Metadata...</span>
        </div>
      }

      @if(uploadSuccessful){
        <div class="alert alert-success mt-2 text-center">
          <i class="bi bi-check-circle me-2"></i> File uploaded successfully!
          <br>
          <small class="text-muted">This window will close automatically in 5 seconds...</small>
        </div>
      }
      
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-secondary"
      [disabled]="isUploading"
      (click)="close()"
    >
      Close
    </button>
    @if (isUploading || savingMetadata) {
      <button [disabled]="true" class="btn btn-primary">
        <i
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></i>
        Uploading...
      </button>
    } @else {
      <button type="button" class="btn custom-btn" [disabled]="!selectedFile || uploadSuccessful" (click)="uploadDocument()">Upload</button>
    }
  </div>